import React from 'react';
import type { AnswerOption } from '../types';

interface ChoiceButtonsProps {
  options: [AnswerOption, AnswerOption];
  onChoose: (optionId: string) => void;
  disabled?: boolean;
  chosenId?: string | null;
  showResult?: boolean;
}

const ChoiceButtons: React.FC<ChoiceButtonsProps> = ({
  options,
  onChoose,
  disabled = false,
  chosenId,
  showResult = false,
}) => {
  const [yes, no] = options;
  const CHOICE_LETTERS = ['A', 'B'] as const;

  const buttonClass = (option: AnswerOption) => {
    const isChosen = chosenId === option.id;

    if (showResult && chosenId) {
      if (option.isCorrect) {
        return 'text-[#22C55E]';
      }
      if (isChosen) {
        return 'text-[#FF3B30]';
      }
      return 'text-black';
    }

    return 'text-black hover:opacity-80 active:scale-[0.99]';
  };

  return (
    <div className="flex flex-col gap-2 w-full">
      <button
        onClick={() => onChoose(yes.id)}
        disabled={disabled}
        className={`flex items-center gap-1.5 w-full py-1.5 px-0 pr-[6px] bg-transparent text-left transition-all duration-150
          ${buttonClass(yes)}
          disabled:cursor-not-allowed`}
        style={{ minHeight: 'clamp(22px, 3.5vh, 36px)' }}
      >
        <span className={`shrink-0 font-normal leading-none ${buttonClass(yes)}`} style={{ fontSize: 'clamp(10px, 2vw, 16px)' }}>
          {CHOICE_LETTERS[0]}.
        </span>
        <span className={`flex-1 font-normal leading-[1.15] ${buttonClass(yes)}`} style={{ fontSize: 'clamp(10px, 2vw, 16px)' }}>
          {yes.text}
        </span>
        {showResult && chosenId && yes.isCorrect && <span className="shrink-0 text-[#22C55E]" style={{ fontSize: 'clamp(10px, 2vw, 16px)' }}>✓</span>}
        {showResult && chosenId && chosenId === yes.id && !yes.isCorrect && <span className="shrink-0 text-[#FF3B30]" style={{ fontSize: 'clamp(10px, 2vw, 16px)' }}>✕</span>}
      </button>
      <button
        onClick={() => onChoose(no.id)}
        disabled={disabled}
        className={`flex items-center gap-1.5 w-full py-1.5 px-0 pr-[6px] bg-transparent text-left transition-all duration-150
          ${buttonClass(no)}
          disabled:cursor-not-allowed`}
        style={{ minHeight: 'clamp(22px, 3.5vh, 36px)' }}
      >
        <span className={`shrink-0 font-normal leading-none ${buttonClass(no)}`} style={{ fontSize: 'clamp(10px, 2vw, 16px)' }}>
          {CHOICE_LETTERS[1]}.
        </span>
        <span className={`flex-1 font-normal leading-[1.15] ${buttonClass(no)}`} style={{ fontSize: 'clamp(10px, 2vw, 16px)' }}>
          {no.text}
        </span>
        {showResult && chosenId && no.isCorrect && <span className="shrink-0 text-[#22C55E]" style={{ fontSize: 'clamp(10px, 2vw, 16px)' }}>✓</span>}
        {showResult && chosenId && chosenId === no.id && !no.isCorrect && <span className="shrink-0 text-[#FF3B30]" style={{ fontSize: 'clamp(10px, 2vw, 16px)' }}>✕</span>}
      </button>
    </div>
  );
};

export default ChoiceButtons;
